<template>
  <div class="wrapper-container">
    <div class="slot-container">
      <slot></slot>
    </div>
    <div class="background-container" v-if="isSerasa">
      <img :src="currentBaseUrl + '/img/page_image_bg.svg'" alt="Clear Background"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BackgroundWrapper',
  computed: {
    ...mapGetters(['isSerasa', 'currentBaseUrl']),
  },
  mounted() {
  console.log('Mounted currentBaseUrl:', this.currentBaseUrl);
},
  methods: {    
    handleClickImage() {
      console.log(this.currentBaseUrl, 'currentBaseUrl')      
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper-container {
  display: flex;
  height: 100%;
}

.slot-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.background-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  display: none;

  @media (min-width: 992px) {
    display: flex;
  }
}

.background-container img {
  max-width: 100%;
  height: auto;
}
</style>
